export default "__VITE_ASSET__ABwfcNGc__"